import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import UpcomingMeetingTable from './UpcomingMeetingTable';
import UpcomingMeeting from './UpcomingMeeting';
import WebinarCount from './WebinarCount';
import ActiveMeetingTable from './ActiveMeetingTable';
import ReportMeetTable from './ReportMeetTable';

const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      sx={{ flexGrow: 1, display: value === index ? 'flex' : 'none', flexDirection: 'column', minHeight: 0 }}
    >
      {value === index && children}
    </Box>
  );
};

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

const MeetTable = () => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        width: '94vw',
        borderRadius: '7px',
        marginLeft: '15px',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: '0px',
        backgroundColor: 'white',
        minHeight: 0,
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: 'divider',paddingLeft:"12px"}}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Overview" {...a11yProps(0)} />
          <Tab label="Running" {...a11yProps(1)} />
          <Tab label="Upcoming" {...a11yProps(2)} />
          <Tab label="Report" {...a11yProps(3)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <WebinarCount />
        <UpcomingMeeting />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <ActiveMeetingTable />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={2}>
        <UpcomingMeetingTable />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={3}>
        <ReportMeetTable />
      </CustomTabPanel>
    </Box>
  );
};

export default MeetTable;
